import React, { useEffect } from "react";
import axios from "axios";
import { environmentalURL } from "../environmentalURL";

function PhishingAwareness() {

  useEffect(() => {

    const trackClick = async () => {

      const alreadyClicked =
        localStorage.getItem(
          "phishing_clicked_data"
        );

      if (alreadyClicked) {
        console.log(
          "Already Counted"
        );
        return;
      }

      try {

        await axios.post(
          `${environmentalURL}/api/phishing/track`
        );

        localStorage.setItem(
          "phishing_clicked_data",
          "YES"
        );

        console.log(
          "Count Added Successfully"
        );

      } catch (error) {

        console.error(error);

      }
    };

    trackClick();

  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px"
      }}
    >
      <h1>
        Security Awareness Exercise
      </h1>

      <p>
        This was a simulated phishing awareness campaign.
      </p>

      <p>
        Always verify email senders before clicking links.
      </p>
    </div>
  );
}

export default PhishingAwareness;